// Generated by Melange

import * as Belt__Belt_Option from "melange.belt/belt_Option.js";
import * as Buhta_cabinet__ControlAdmin from "../../../grpc/ControlAdmin.js";
import * as Buhta_cabinet__DummyTable from "../../../components/molecules/Table/DummyTable.js";
import * as Buhta_cabinet__ErrorPage from "../../ErrorPage.js";
import * as Buhta_cabinet__PageNav from "../../../components/molecules/PageNav.js";
import * as Buhta_cabinet__Search from "../../../components/molecules/Search/Search.js";
import * as Buhta_cabinet__Table2 from "../../../components/molecules/Table/Table2.js";
import * as Buhta_cabinet__Timestamp from "../../../util/Timestamp.js";
import * as Buhta_components__CopyButton from "../../../../../../packages/components/src/CopyButton.js";
import * as Buhta_components__Text from "../../../../../../packages/components/src/html/Text.js";
import * as Buhta_core__GrpcState from "../../../../../../packages/core/lib/GrpcState.js";
import * as Cn from "../../../../../../vendored/classnames/Cn.js";
import * as Curry from "melange.js/curry.js";
import * as DateTime from "../../../../../../packages/util/lib/DateTime.js";
import * as Formating from "../../../../../../packages/util/lib/Formating.js";
import * as StaticAsset from "../../../../../../packages/util/lib/StaticAsset.js";
import * as Stdlib__List from "melange/list.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function IdentitiesPage(Props) {
  const match = React.useState(function () {
    return 1;
  });
  const setPage = match[1];
  const page = match[0];
  const match$1 = Buhta_core__GrpcState.useGrid(Buhta_cabinet__ControlAdmin.AdminIdentityService.grid, undefined);
  const dispatch = match$1[1];
  const grid = match$1[0];
  const currentRecords = typeof grid === "string" || grid.NAME !== "Data" ? 0 : Stdlib__List.length(grid.VAL);
  const rows = typeof grid === "string" || grid.NAME !== "Data" ? /* [] */ 0 : Stdlib__List.mapi((function (i, identity) {
      const profile = identity.profile;
      const profile$1 = profile !== undefined ? profile : ({
          id: 0,
          email: "",
          phone: "",
          first_name: "",
          last_name: "",
          userpic_url: "",
          tenants: /* [] */ 0,
          create_time: undefined
        });
      const create_time = DateTime.toDateFormat(Buhta_cabinet__Timestamp.toDateTime(Belt__Belt_Option.getWithDefault(profile$1.create_time, Buhta_cabinet__Timestamp.fromString("01.01.2000"))));
      let tmp;
      if (profile$1.phone !== "") {
        const phone = profile$1.phone;
        tmp = phone.includes(" ", undefined) ? phone : Formating.formatPhone(phone);
      } else {
        tmp = JsxRuntime.jsx("span", {
          children: "Не указано",
          className: "text-asphalt"
        });
      }
      const cells_0 = {
        body: JsxRuntime.jsxs(Buhta_components__Text.PSmall.make, {
          className: "flex items-center gap-1",
          children: [
            profile$1.first_name + (" " + profile$1.last_name),
            JsxRuntime.jsx(Buhta_components__CopyButton.make, {
              text: profile$1.first_name + (" " + profile$1.last_name)
            })
          ]
        }),
        style: ""
      };
      const cells_1 = {
        hd: {
          body: JsxRuntime.jsx("div", {
            children: JsxRuntime.jsxs(Buhta_components__Text.PSmall.make, {
              className: "flex items-center gap-1",
              children: [
                tmp,
                JsxRuntime.jsx(Buhta_components__CopyButton.make, {
                  text: profile$1.phone
                })
              ]
            }),
            className: "flex items-center"
          }),
          style: ""
        },
        tl: {
          hd: {
            body: JsxRuntime.jsx("div", {
              children: JsxRuntime.jsxs(Buhta_components__Text.PSmall.make, {
                className: "flex items-center gap-1",
                children: [
                  profile$1.email !== "" ? profile$1.email : JsxRuntime.jsx("span", {
                      children: "Не указано",
                      className: "text-asphalt"
                    }),
                  JsxRuntime.jsx(Buhta_components__CopyButton.make, {
                    text: profile$1.email
                  })
                ]
              }),
              className: "flex items-center"
            }),
            style: ""
          },
          tl: {
            hd: {
              body: create_time,
              style: "justify-end"
            },
            tl: /* [] */ 0
          }
        }
      };
      const cells = {
        hd: cells_0,
        tl: cells_1
      };
      const Key = String(i);
      return JsxRuntime.jsx(Buhta_cabinet__Table2.Row.make, {
        cells: cells,
        route: {
          TAG: /* Admin */ 7,
          _0: {
            TAG: /* Identities */ 2,
            _0: {
              TAG: /* Item */ 0,
              _0: identity.id,
              _1: /* General */ 0
            }
          }
        }
      }, Key);
    }), grid.VAL);
  React.useEffect((function () {
    Curry._3(dispatch, undefined, undefined, undefined);
  }), []);
  return JsxRuntime.jsxs(React.Fragment, {
    children: [
      JsxRuntime.jsx(Buhta_cabinet__Search.make, {
        dispatch: dispatch,
        page: page,
        setPage: setPage
      }),
      typeof grid === "string" ? (
          grid === "Loading" ? JsxRuntime.jsx(Buhta_cabinet__DummyTable.make, {}) : JsxRuntime.jsx(Buhta_cabinet__ErrorPage.make, {})
        ) : (
          grid.NAME === "Data" ? JsxRuntime.jsxs(React.Fragment, {
              children: [
                JsxRuntime.jsx("div", {
                  children: Stdlib__List.length(grid.VAL) > 0 ? JsxRuntime.jsx(Buhta_cabinet__Table2.make, {
                      header: {
                        hd: {
                          name: "Пользователь",
                          style: ""
                        },
                        tl: {
                          hd: {
                            name: "Номер телефона",
                            style: ""
                          },
                          tl: {
                            hd: {
                              name: "Почта",
                              style: ""
                            },
                            tl: {
                              hd: {
                                name: "Дата создания",
                                style: "text-right"
                              },
                              tl: /* [] */ 0
                            }
                          }
                        }
                      },
                      rows: rows,
                      styles: Cn.$plus("grid", "grid-cols-4")
                    }) : JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("img", {
                          className: "w-10 h-10",
                          src: StaticAsset.src("/static/icons/piechart-40.svg")
                        }),
                        JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                          className: "mt-6 text-default-gray",
                          children: "Нет записей"
                        })
                      ],
                      className: "flex flex-col items-center col-span-9 mt-84"
                    }),
                  className: "flex-1 overflow-auto"
                }),
                JsxRuntime.jsx(Buhta_cabinet__PageNav.make, {
                  page: page,
                  setPage: setPage,
                  currentRecords: currentRecords
                })
              ]
            }) : JsxRuntime.jsx(Buhta_cabinet__ErrorPage.make, {})
        )
    ]
  });
}

const make = IdentitiesPage;

export {
  make,
}
/* Buhta_cabinet__ControlAdmin Not a pure module */
